import Icon from "components/ui/Icon";
import React from "react";
import styled from "styled-components";

const Checkmark = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: none;

  pointer-events: none;

  svg {
    display: block;

    * {
      stroke-width: 40px;
      stroke: white;
    }
  }
`;

const StyledCheckbox = styled.input<{ $hasError?: boolean }>`
  display: block;
  height: 24px;
  width: 24px;
  margin: 0;
  padding: 0;
  flex: 0 0 auto;

  background: white;
  border: 1px solid ${(props) => props.theme.colors.text}40;
  border-radius: 4px;
  outline: 0;
  appearance: none;

  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes.sm}px;

  &:focus {
    border-color: ${(props) => props.theme.colors.text};
    box-shadow: ${(props) => props.theme.shadows.regular};
  }

  &:checked {
    background: ${(props) => props.theme.colors.accent};

    & + ${Checkmark} {
      display: block;
    }
  }

  ${(props) =>
    props.$hasError
      ? `
  border-color: ${(props) => props.theme.colors.danger};
  `
      : ""}
`;

const Wrapper = styled.div`
  position: relative;

  display: inline-block;
`;

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: any;
  hasError?: boolean;
}

const Checkbox: React.ForwardRefRenderFunction<
  HTMLInputElement,
  CheckboxProps
> = ({ name, onChange, hasError, ...props }, ref) => (
  <Wrapper>
    <StyledCheckbox
      name={name}
      type="checkbox"
      onChange={onChange}
      ref={ref}
      $hasError={hasError}
      {...props}
    />

    <Checkmark>
      <Icon name="checkmark" size="xs" color="accent" reverse />
    </Checkmark>
  </Wrapper>
);

export default React.forwardRef(Checkbox);
